import { useMemo } from 'react';

import classNames from 'classnames';

import styles from '@components/Dashboard/AccountSnapshot/AccountSnapshot.module.css';

import { BootstrapTable } from '@components/Table/Table';

const renderFlagCell = ({ row, value }) => {
  const { style } = row.getToggleRowExpandedProps();
  if (row.canExpand) {
    return (
      <span role="presentation" style={style}>
        {row.isExpanded ? '-' : '+'}
      </span>
    );
  }
  if (!value) {
    return null;
  }
  return <img className={styles.snapshotImgRound} src={value} alt={value} />;
};

export const AccountSnapshotTable = ({ data }) => {
  const columns = useMemo(
    () => [
      {
        id: 'flag',
        Header: '',
        Cell: renderFlagCell,
        accessor: 'country.flag_href',
        className: 'col-md-1',
      },
      { Header: 'Country', accessor: 'country.name', className: 'col-md-4' },
      {
        Header: 'Active numbers',
        accessor: 'dids_amount',
        className: 'col-md-2',
      },
      {
        Header: 'Inbound min 7 days',
        accessor: 'minutes_last_7_days.inbound',
        className: 'col-md-1',
        setMinWidth: '90px',
      },
      {
        Header: 'Outbound min 7 days',
        accessor: 'minutes_last_7_days.outbound',
        className: 'col-md-1',
        setMinWidth: '90px',
      },
    ],
    []
  );
  return (
    <BootstrapTable
      columns={columns}
      data={data}
      tableProps={() => ({ responsive: true, borderless: true })}
      headerProps={() => ({ className: 'text-center' })}
      rowProps={(row) => ({
        className: classNames({ 'border-bottom': row.isExpanded }),
      })}
      cellProps={() => ({ className: 'text-center' })}
    />
  );
};
